import React from "react";
import "../styles/About.css";

function About() {
  return (
    <div className="about-main">
      <div className="about-flex">
        <div className="about-photo-box">
          <img src="/HemantPic1.jpeg" alt="Principal Hemant" className="about-photo" />
          <div className="about-principal-caption">
            <span>Principal</span>
          </div>
        </div>
        <div className="about-container">
          <h1>About Sarojini Group of Institutes</h1>
          <p>
            Sarojini Group of Institutes, Dhule, is a premier educational institution committed to fostering excellence in healthcare education. Established under the vision of the Aadhar Foundation, we nurture competent, compassionate professionals who contribute to society with dedication and integrity.
          </p>
          <h2>Our Mission</h2>
          <p>
            To provide high-quality education and practical training, ensuring our students are well-prepared for real-world healthcare challenges.
          </p>
          <h2>Our Values</h2>
          <ul>
            <li>Academic Excellence</li>
            <li>Empathy & Compassion</li>
            <li>Integrity & Commitment</li>
            <li>Community Service</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default About;